import { render, staticRenderFns } from "./communityGrid.vue?vue&type=template&id=d8c519f8&scoped=true&"
import script from "./communityGrid.vue?vue&type=script&lang=js&"
export * from "./communityGrid.vue?vue&type=script&lang=js&"
import style0 from "./communityGrid.vue?vue&type=style&index=0&id=d8c519f8&lang=scss&scoped=true&"
import style1 from "./communityGrid.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c519f8",
  null
  
)

export default component.exports